import { render, staticRenderFns } from "./WhitelabelReseller.vue?vue&type=template&id=559d7ba2&"
import script from "./WhitelabelReseller.vue?vue&type=script&lang=js&"
export * from "./WhitelabelReseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports